import React from 'react';

import styles from './ArticleEditorFooter.module.css';

import { RectangleButton } from 'components/shared/RectangleButton';
import { useIntlContext } from 'hooks/useIntlContext';

type TProps = {
  hasPreloader: boolean;
  testId?: string;
  onClick(): void;
};

export const ArticleEditorFooterSubmitDraftButton = (props: TProps) => {
  const { onClick, hasPreloader, testId } = props;

  const { articleEditorFooterSubmitDraftButtonLabel: label } = useIntlContext();

  return (
    <RectangleButton
      hasPreloader={hasPreloader}
      testIdButton={testId}
      className={styles.ArticleEditorFooter__SubmitDraftButton}
      label={label}
      onClick={onClick}
      styleType={'secondary'}
    />
  );
};
